import { downloadFile } from './downloadFile';
import { message } from 'antd';
import { classify401, endSession } from '@auth';

type DownloadZipProps = {
  url: string;
  headers: RequestInit;
  fileName: string;
};

export const downloadZip = async ({ url, headers, fileName }: DownloadZipProps) => {
  const response = await fetch(url, headers);

  if (response.status === 401) {
    // This fetch bypasses the axios client, so nothing else calls the shared session-ended
    // handling that every other 401 in the app goes through. Do it here, then throw: distinct
    // from "no files", so this isn't reported as a successful, empty download.
    const data = await response.json().catch(() => undefined);
    endSession(classify401(data));
    throw new Error('Unauthorized');
  }

  if(!response.ok) {
    message.error('No files mathing your request');
    return;
  }

  const file = await response.blob();

  const newUrl = window.URL.createObjectURL(file);
  downloadFile(newUrl, fileName)
};